import './styles/cta-two.css'
import SubTitle from './core/SubTitle'
import Text from './core/Text'
import BlueBtn from './UI/BlueBtn'
import ctaImg1 from '../assets/images/img1.png'
import ctaImg3 from '../assets/images/img3.png'
import chrome from '../assets/icons/chrome.svg'
import mozilla from '../assets/icons/mozilla.svg'

export default function CtaTwo() {
  return (
    <div className='cta-two'>
        <div className='cta-two__item first'>
            <div className='cta-two__item-info first'>
                <div className='cta-two__item-title first'>
                <SubTitle text='Applicant Tracking Systems (ATS)'/>
                </div>
                <div className="cta-two__item-text first">
                <Text
                customClass='cta-two__item-text-tranform1 first'
                color='#404046'
                text={`Wondering why sometimes your applications seem to disappear into cyberspace? 
                You’re not alone. Most companies use applicant tracking systems (ATS) to filter out applicants 
                based on key skills present in applicant resumes before anyone even sees the application.`}
                />
                <Text
                customClass='cta-two__item-text-tranform2 first'
                color='#404046'
                text={`
                Applicants are often more than qualified for the job, 
                but a poor resume prevents them from ever getting a shot. 
                Resume Raise has been created to change that by providing 
                every quality candidate with the tools to beat ATS.
                `}
                />
                </div>
                <div className='cta-two__item-btn first'>
                    <BlueBtn text={'Get started'} width={'120'}/>
                </div>
                <div className='cta-two__item-elipse first'>
                    <div className='cta-two__item-elipse-body'></div>
                </div>
            </div>
            <div className='cta-two__item-img first desktop-img'>
                <img src={ctaImg1} alt={'cta-two-img'}/>
            </div>
            <div className='cta-two__item-img first mobile-img'>

            </div>
        </div>
        <div className='cta-two__item second reverse'>
            <div className='cta-two__item-info second'>
                <div className='cta-two__item-title second'>
                    <SubTitle text='Optimize and Scan your LinkedIn Profile with our browser extension'/>
                </div>
                <div className="cta-two__item-text second">
                <Text
                color='#404046'
                text={`Be noticed by professionals. Download the Resume 
                Raise browser extension, and optimize your LinkedIn 
                profile for searches free of charge. Be noticed by professionals. 
                Download the Resume Raise browser extension, and optimize your 
                LinkedIn profile for searches free of charge.`}
                />
                </div>
                <div className='cta-two__item-buttons'>
                    <a className='cta-two__item-button' href='/'>
                        <div className='cta-two__item-button-img'>
                            <img src={chrome} alt="chrome" />
                        </div>
                        <div className='cta-two__item-button-line'>

                        </div>
                        <div className='cta-two__item-button-text'>
                            <div className="cta-two__item-button-key">
                                Download extension
                            </div>
                            <div className="cta-two__item-button-value">
                                Google Chrome
                            </div>
                        </div>                        
                    </a>
                    <a className='cta-two__item-button' href='/'>
                        <div className='cta-two__item-button-img'>
                            <img src={mozilla} alt="mozilla" />
                        </div>
                        <div className='cta-two__item-button-line'>

                        </div>
                        <div className='cta-two__item-button-text'>
                            <div className="cta-two__item-button-key">
                                Download extension
                            </div>
                            <div className="cta-two__item-button-value">
                            Mozilla Firefox
                            </div>
                        </div>                        
                    </a>
                </div>
                <div className='cta-two__item-elipse second'>
                    <div className='cta-two__item-elipse-body'></div>
                </div>
            </div>
            <div className='cta-two__item-img second desktop-img'>
                <img src={ctaImg3} alt={'cta-two-img'}/>
            </div>
            <div className='cta-two__item-img second mobile-img'>

            </div>
        </div>
    </div>
  )
}
